import styled from "styled-components";
import { useLanguage } from "../contexts/LanguageContext";

const LangToggle = ({ variant = "header" }) => {
  const { isFr, toggleLang } = useLanguage();
  const nextLang = isFr ? "en" : "fr";
  const full = isFr ? "English" : "Français";
  const abbr = isFr ? "EN" : "FR";

  return (
    <Btn
      type="button"
      $variant={variant}
      onClick={toggleLang}
      lang={nextLang}
      title={full}
      translate="no"
      aria-label={full}
    >
      <Full>{full}</Full>
      <Abbr aria-hidden="true">{abbr}</Abbr>
    </Btn>
  );
};

export default LangToggle;

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: ${(p) => (p.$variant === "hero" ? "42px" : "40px")};
  min-width: ${(p) => (p.$variant === "hero" ? "42px" : "40px")};
  padding: 0 10px;
  border-radius: var(--radius-pill);
  background: ${(p) =>
    p.$variant === "hero" ? "rgba(15, 15, 16, 0.55)" : "transparent"};
  border: 1px solid
    ${(p) =>
      p.$variant === "hero" ? "rgba(247, 243, 236, 0.28)" : "currentColor"};
  color: ${(p) => (p.$variant === "hero" ? "#f7f3ec" : "inherit")};
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.06em;
  line-height: 1;
  flex-shrink: 0;

  @media (min-width: 1024px) {
    font-size: 13px;
    letter-spacing: 0.02em;
    padding: 0 12px;
    min-width: 0;
  }
`;

const Full = styled.span`
  display: none;

  @media (min-width: 1024px) {
    display: inline;
  }
`;

const Abbr = styled.span`
  display: inline;

  @media (min-width: 1024px) {
    display: none;
  }
`;
